import { Header, Footer } from '@/shared/components/layout';
import { useDocumentTitle } from '@/shared/hooks';
import { PricingQA } from '@/features/Pricing/Components/PricingQA';
import { TryItFree } from '@/features/Pricing/Components/TryItFree';

const FAQPage = () => {
  useDocumentTitle('Frequently Asked Questions - BrokerMax');
  return (
    <div className="min-h-screen">
      <Header variant="light-hero" />
      <main>
        <PricingQA />
        <TryItFree />
      </main>
      <Footer />
    </div>
  );
};

export default FAQPage;
